import React from 'react';

import PropTypes from 'prop-types';

import './SectionMidTitle.sass';

export const SectionMidTitle = ({ children }) => (
  <div className="section-mid-title">{children}</div>
);

SectionMidTitle.propTypes = {
  children: PropTypes.node,
};

SectionMidTitle.defaultProps = {
  children: null,
};
